import React, { memo, useMemo, useState, useEffect, useContext } from 'react';
import { ENTITIES } from "../../../lib/constants";
import { useWeb5Context } from "../../../lib/Web5Context";
import { getTables } from "../../../lib/services/imports";
import SectionTabs from "../../../components/SectionTabs";
import { getDescription } from "../../../utils/custom";
import ImportContext from "./../ImportContext";
const defaultTabs = [{
  key: ENTITIES.ACCOUNTS.importExport,
  title: 'cfm_label_accounts'
}, {
  key: ENTITIES.CONTACTS.importExport,
  title: 'cfm_label_contacts'
}, {
  key: ENTITIES.OPPORTUNITIES.importExport,
  title: 'cfm_label_opportunities'
}, {
  key: ENTITIES.USERS.importExport,
  title: 'cfm_label_users'
}
/*{
    key: ENTITIES.ACTIVITIES.importExport,
    title: 'cfm_label_activities',
},
{
    key: ENTITIES.CALENDAR.importExport,
    title: 'cfm_label_event_task',
},
{
    key: ENTITIES.SALESORDERS.importExport,
    title: 'cfm_label_salesorders',
},
{
    key: ENTITIES.PRODUCTS.importExport,
    title: 'cfm_label_products',
},*/];
const ImportsTabs = _ref => {
  let {
    onChange,
    onChangeShrinked,
    activeTab,
    activeShrinkedTab,
    idSetupRole,
    isNotAdmin
  } = _ref;
  const {
    t,
    permissions: contextPermissions
  } = useWeb5Context();
  const {
    permissions: externalPermissions
  } = useContext(ImportContext);
  const permissions = externalPermissions || contextPermissions;
  const {
    permissions: rolesPermissions
  } = permissions;
  const [shrinkedTabs, setShrinkedTabs] = useState([]);
  const tabs = useMemo(() => defaultTabs.filter(tab => {
    if (rolesPermissions !== null && rolesPermissions !== void 0 && rolesPermissions.editFromWeb) return (tab === null || tab === void 0 ? void 0 : tab.key) !== ENTITIES.USERS.importExport;else return tab;
  }).map(_ref2 => {
    let {
      key,
      title
    } = _ref2;
    return {
      key,
      title: t(title)
    };
  }), [rolesPermissions === null || rolesPermissions === void 0 ? void 0 : rolesPermissions.editFromWeb, t]);
  const dumbUser = idSetupRole ? [8, 9].includes(idSetupRole) : false;
  useEffect(() => {
    if (isNotAdmin) return;
    getTables().then(_ref3 => {
      let {
        data
      } = _ref3;
      if (!data) return;
      setShrinkedTabs(data.filter(_ref4 => {
        let {
          name
        } = _ref4;
        return !tabs.find(tab => name.toLowerCase() === tab.key.toLowerCase());
      }).map(tab => ({
        label: getDescription({
          tab,
          dumbUser
        }),
        value: tab.name,
        description: (tab === null || tab === void 0 ? void 0 : tab.description) || null
      })));
    }).catch(console.error);
    // setShrinkedTabs([]);
  }, [tabs, dumbUser, isNotAdmin]);
  return /*#__PURE__*/React.createElement("div", {
    id: "fm-imports__tabs"
  }, /*#__PURE__*/React.createElement(SectionTabs, {
    onChangeShrinked: !isNotAdmin && onChangeShrinked,
    onChange: onChange,
    activeTab: activeTab,
    activeShrinkedTab: !isNotAdmin && activeShrinkedTab,
    tabs: tabs,
    shrinkedTabs: !isNotAdmin && shrinkedTabs
  }));
};
process.env.NODE_ENV !== "production" ? ImportsTabs.propTypes = {} : void 0;
export default /*#__PURE__*/memo(ImportsTabs);